<template>
  <InlineSvg :src="src" v-bind="$attrs"></InlineSvg>
</template>

<script lang="ts" setup>
import { toRefs, computed } from 'vue';
import InlineSvg from 'vue-inline-svg';

const props = defineProps<{
  name: string;
}>();
const { name } = toRefs(props);

const src = computed(() => {
  return new URL(`../assets/svg/${name.value}.svg`, import.meta.url).href;
});
</script>

<style lang="scss" scoped>
svg {
  display: inherit;
}
</style>
